/* eslint-disable arrow-body-style */
/* eslint-disable semi */
export default () => {
  return `
    <div class="container section  section__panel section__large">
      <div class="panel__heading d-flex text-left">
        <span>Create Your Team</span>
      </div>

      <div class="panel__body">
        <div class="row align-items-center justify-content-center">
          <div class="col-3 text-right d-flex justify-content-end align-items-center">
            <img class="section-head__image" src="/assets/images/ic_group_add.svg" alt="">
            <a href="#multiple_purchase">
              <button class="btn btn-new mt-4">Purchase Now ></button>
            </a>
          </div>
          <div class="col-3 text-right d-flex justify-content-center align-items-center">
            <img class="img-fluid" src="/assets/images/game-dashboard/players.png" alt="" />
          </div>
          <div class="col-3 text-right d-flex justify-content-start align-items-center">
            <img class="section-head__image" src="/assets/images/stadium.svg" alt="" />
            <button class="btn btn-new mt-4 createTeam">Create Your Team ></button>
          </div>
        </div>
      </div>
    </div>
  `
};
